import {
  and,
  ControlProps,
  RankedTester,
  rankWith,
  schemaMatches,
} from "@jsonforms/core";
import {
  FormDetailItem,
  FormDetailValue,
  FormDetailWrapper,
} from "../../messageType/contentType/FormContent.style";
import React from "react";
import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import { formatDisplayPhoneNumber } from "hhn-commons";
import { CountryCode } from "@home-health-notify/domain";

const PhoneNumberViewRenderer = ({ data, label, uischema }: ControlProps) => {
  const { options } = uischema;
  const ctx = useJsonForms();
  const rootData = ctx.core?.data;

  const countryCodePath = options?.countryCodePath;
  let countryCode = CountryCode.US; // default

  // If countryCodePath is provided in options, use it to get value from form data
  if (countryCodePath && rootData) {
    const parts = countryCodePath.split(".");
    let current: any = rootData;
    for (const part of parts) {
      current = current?.[part];
    }
    if (current) {
      countryCode = current;
    }
  }

  const formattedPhoneNumber = formatDisplayPhoneNumber(
    countryCode,
    data.toString(),
  )
    ? formatDisplayPhoneNumber(countryCode, data.toString())
    : "N/A";
  return (
    <FormDetailWrapper data-testid="form-content-item">
      <FormDetailItem>{label} :</FormDetailItem>
      <FormDetailValue>{formattedPhoneNumber}</FormDetailValue>
    </FormDetailWrapper>
  );
};

export const phoneNumberViewTester: RankedTester = rankWith(
  6,
  and(
    schemaMatches(schema => {
      return schema.type === "string" && schema.maxLength === 10;
    }),
  ),
);

export default withJsonFormsControlProps(PhoneNumberViewRenderer);
